import { createRouter, createWebHistory } from "vue-router";
import Audits from "../views/audits.vue";
import soon from "../views/coming_soon.vue";
import Dashboard from "../views/Dashboard.vue";
import Forgot from "../views/forgot_password.vue";
import Preview from "../views/mappings_preview.vue";
import Profile from "../views/Profile.vue";
import UrpPackages from "../views/zipped_reports.vue";
import ProcessedFiles from "../views/processed_files.vue";
import configuration from "../views/report_configuration.vue";
import Settings from "../views/settings.vue";
import SignUp from "../views/SignUp.vue";
import SignIn from "../views/mfa.vue";
import Users from "../views/users.vue";
import ErrorsView from "../views/errors.vue";
import Licenses from "../views/licenses.vue";
import store from "@/store";

const routes = [
  {
    path: "/",
    name: "/",
    redirect: "/dashboard",
    meta: { requiresAuth: true, showLayout: true },
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    meta: { requiresAuth: true, showLayout: true },
  },
  {
    path: "/systemusers",
    name: "System Users",
    component: Users,
    meta: { requiresAuth: true, showLayout: true },
  },
  {
    path: "/processed-files",
    name: "RRI Report Files",
    component: ProcessedFiles,
    meta: { requiresAuth: true, showLayout: true },
  },
  {
    path: "/urp-packages",
    name: "URP Packages",
    component: UrpPackages,
    meta: { requiresAuth: true, showLayout: true },
  },
  {
    path: "/settings",
    name: "System Settings",
    component: Settings,
    meta: { requiresAuth: true, showLayout: true },
  },
  {
    path: "/auditlogs",
    name: "System Audit Logs",
    component: Audits,
    meta: { requiresAuth: true, showLayout: true },
  },
  {
    path: "/comingsoon",
    name: " ",
    component: soon,
    meta: { requiresAuth: true, showLayout: true },
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
    meta: { requiresAuth: true, showLayout: true },
  },
  {
    path: "/reportconfiguration",
    name: "Report Configuration",
    component: configuration,
    meta: { requiresAuth: true, showLayout: true },
  },
  {
    path: "/viewreportconfigurations",
    name: "View Data Mappings",
    component: Preview,
    meta: { requiresAuth: true, showLayout: true },
  },
  {
    path: "/licenses",
    name: "Licenses",
    component: Licenses,
    meta: { requiresAuth: true, showLayout: true },
  },
  {
    path: "/sign-in",
    name: "SignIn",
    component: SignIn,
    meta: { requiresAuth: false, showLayout: false },
  },
  {
    path: "/sign-up",
    name: "SignUp",
    component: SignUp,
    meta: { requiresAuth: false, showLayout: false },
  },
  {
    path: "/forgot-password",
    name: "Forgot Password",
    component: Forgot,
    meta: { requiresAuth: false, showLayout: false },
  },
  {
    path: "/errors",
    name: "Errors",
    component: ErrorsView,
    meta: { requiresAuth: true, showLayout: true },
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

router.beforeEach((to, from, next) => {
  // Wait for auth initialization to complete if still loading
  if (store.getters["auth/isAuthLoading"]) {
    // Auth is still being initialized, wait
    const checkAuth = setInterval(() => {
      if (!store.getters["auth/isAuthLoading"]) {
        clearInterval(checkAuth);
        handleNavigation(to, next);
      }
    }, 100);
  } else {
    handleNavigation(to, next);
  }

  function handleNavigation(to, next) {
    const isAuthenticated = store.getters["auth/isAuthenticated"];

    if (to.meta.requiresAuth && !isAuthenticated) {
      // Redirect to login if trying to access protected route
      next("/sign-in");
    } else if (
      (to.path === "/sign-in" ||
        to.path === "/sign-up" ||
        to.path === "/forgot-password") &&
      isAuthenticated
    ) {
      // Redirect to dashboard if trying to access login page while logged in
      next("/dashboard");
    } else {
      next();
    }
  }
});

export default router;
